/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S8_Li3_DescInputs */

const tr_iade_iptal_s8_li3_desc = /** @type {(inputs: Iade_Iptal_S8_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik'in 3 (üç) ay süreyle hiç kullanılmaması; bu halde fesih öncesi e-posta ile bildirim yapılır.`)
};

const en_iade_iptal_s8_li3_desc = /** @type {(inputs: Iade_Iptal_S8_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No use of the Subscription for a period of 3 (three) months; in this case notice is given by email before termination.`)
};

const de_iade_iptal_s8_li3_desc = /** @type {(inputs: Iade_Iptal_S8_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keinerlei Nutzung des Abonnements über einen Zeitraum von 3 (drei) Monaten; in diesem Fall erfolgt vor der Beendigung eine Mitteilung per E-Mail.`)
};

const ru_iade_iptal_s8_li3_desc = /** @type {(inputs: Iade_Iptal_S8_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полное неиспользование Подписки в течение 3 (трёх) месяцев; в этом случае перед расторжением направляется уведомление по электронной почте.`)
};

/**
* | output |
* | --- |
* | "No use of the Subscription for a period of 3 (three) months; in this case notice is given by email before termination." |
*
* @param {Iade_Iptal_S8_Li3_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s8_li3_desc = /** @type {((inputs?: Iade_Iptal_S8_Li3_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S8_Li3_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s8_li3_desc(inputs)
	if (locale === "de") return de_iade_iptal_s8_li3_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s8_li3_desc(inputs)
	return tr_iade_iptal_s8_li3_desc(inputs)
});